import { schema } from 'normalizr'
import { pick } from 'ramda'
import * as PROPS from 'constants/spProperties'
import * as TYPES from 'constants/spTypes'

const spTransformers = {
  [TYPES.O_MLOGIC]: normalizeMLogic,
  [TYPES.N_MLOGIC]: normalizeMLogic,
  [TYPES.N_MLOGIC2]: normalizeMLogic,
}

export const supportParameterSchema = new schema.Entity(
  'supportParameters',
  {},
  {
    idAttribute: 'uri',
    processStrategy: (value) =>
      spTransformers[value.supportParameterType]
        ? spTransformers[value.supportParameterType](value)
        : value,
  }
)

export const supportParameterResponseSchema = new schema.Object({
  supportParameter: supportParameterSchema,
})

function normalizeMLogic(supportParameter) {
  const normalized = pick([
    PROPS.STATUS,
    PROPS.ID,
    PROPS.URI,
    PROPS.DESCRIPTION,
    PROPS.SUPPORTPARAMETERTYPE,
    PROPS.ROWID,
  ])(supportParameter)

  const inputs = PROPS.mLogicInputs.reduce((accum, key) => {
    const lowercaseKey = key.toLowerCase()
    return {
      ...accum,
      [key]: {
        operator: supportParameter[`${lowercaseKey}_op`],
        value: supportParameter[`${lowercaseKey}_value`],
        logicalSlot: supportParameter[`${lowercaseKey}_ls`],
      },
    }
  }, {})

  return {
    ...normalized,
    ...(supportParameter.mlogic_slot_name && {
      mLogicSlotName: supportParameter.mlogic_slot_name,
    }),
    ...(supportParameter.rowid && { rowid: supportParameter.rowid }),
    inputs,
    logicalSlot: supportParameter.cout_ls,
    taskId: supportParameter.cout_task_id,
    outputDefault: supportParameter.cout_default,
    outputFalse: supportParameter.cout_false,
    outputTrue: supportParameter.cout_true,
  }
}
